import { render, staticRenderFns } from "./_Registration.vue?vue&type=template&id=7f9a6670&scoped=true"
import script from "./_Registration.vue?vue&type=script&lang=js"
export * from "./_Registration.vue?vue&type=script&lang=js"
import style0 from "./_Registration.vue?vue&type=style&index=0&id=7f9a6670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9a6670",
  null
  
)

export default component.exports